import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { deleteUser, findAllUser, resetCreateUserRequest, setOpenConfirmModal, setUserId } from "./slice";
import { useAppSelector, useAppDispatch } from "../../lib/redux/hook";
import { EditIcon } from "../../ui/icons/editIcon";
import { TrashIcon } from "../../ui/icons/trashIcon";
import { SpinnerComponent } from "../../ui/molecules/spinner";
import { ConfirmModal } from "../../ui/organisms/confirmModal";
import { Dropdown } from "../../ui/organisms/dropDown";

export function UserList() {
    const userState = useAppSelector(state => state.user)
    const authState = useAppSelector(state => state.auth)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const [isDelete, setIsDelete] = useState<string | undefined>()

    useEffect(() => {
        dispatch(findAllUser(userState.userFilters))
    }, [])

    useEffect(() => {
        if (userState.createUserStatus === "successfully") {
            dispatch(findAllUser(userState.userFilters))
            dispatch(resetCreateUserRequest())
        }
    }, [userState.createUserStatus])

    useEffect(() => {
        if (userState.createUserStatus === "failed") {
            dispatch(resetCreateUserRequest())
        }
    }, [userState.createUserStatus])

    useEffect(() => {
        if (userState.deleteUserStatus === "successfully") {
            dispatch(findAllUser(userState.userFilters))
        }
    }, [userState.deleteUserStatus])

    useEffect(() => {
        if (userState.editUserStatus === "successfully") {
            dispatch(findAllUser(userState.userFilters))
        }
    }, [userState.editUserStatus])

    if (userState.findAllUserStatus === "loading" || userState.createUserStatus === "loading" || userState.deleteUserStatus === "loading" || userState.editUserStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <SpinnerComponent />
            </div>
        )
    }

    return (
        <div className="w-full flex flex-col gap-4 bg-neutral-100 rounded-tr-xl rounded-tl-xl overflow-auto">
            <div>
                <table className="w-full">
                    <thead className="h-[56px] font-semibold text-neutral-500 text-text-xs">
                        <tr>
                            <th className="text-left">
                                <div className="flex py-4 px-4 gap-1">
                                    NOME
                                </div>
                            </th>
                            {
                                userState.findAllUserResponse?.users.length !== 0 &&
                                <>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            COGNOME
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            EMAIL
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            AZIENDA
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            RUOLO
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1" />
                                    </th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            userState.findAllUserResponse?.users.length === 0 ?
                                <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 w-full">
                                    <td className="py-4 px-4 text-text-sm font-medium text-neutral-500">
                                        Nessun utente
                                    </td>
                                </tr>
                                :
                                userState.findAllUserResponse?.users.map(item =>
                                    <tr
                                        className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                                        key={item.id}
                                    >
                                        <td onClick={() => {
                                            dispatch(setUserId(item.id.toString()))
                                        }} className="py-4 px-2 text-text-sm font-semibold text-neutral-600 hover:text-neutral-500 cursor-pointer">{item.name.length <= 20 ? item.name : item.name.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.surname.length <= 20 ? item.surname : item.surname.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.email.length <= 20 ? item.email : item.email.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.company.length <= 20 ? item.company : item.company.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.role === 1 ? 'Admin' : 'Operatore'}</td>
                                        <td className="w-[40px] cursor-pointer">
                                            <Dropdown items={[
                                                {
                                                    label: 'Modifica',
                                                    icon: <EditIcon color="" size={""} />,
                                                    onClick: () => {
                                                        dispatch(setUserId(item.id.toString()))
                                                    }
                                                },
                                                {
                                                    label: 'Cancella',
                                                    icon: <TrashIcon color="" size={""} />,
                                                    onClick: () => {
                                                        setIsDelete(item.id.toString())
                                                        dispatch(setOpenConfirmModal(true))
                                                    },
                                                    visible: item.email === authState.findMeUserResponse?.email
                                                }
                                            ]} />
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>
            <ConfirmModal
                open={userState.openConfirmModal}
                handleClose={() => dispatch(setOpenConfirmModal(false))}
                title={"Elimina utente"}
                description={"Sei sicuro di voler eliminare questo utente?"}
                labelDeny={"Annulla"}
                labelConfirm={"Elimina"}
                actionConfirm={() => {
                    isDelete && dispatch(deleteUser(isDelete))
                    dispatch(setOpenConfirmModal(false))
                }}
            />
        </div>
    )
}